import { mq, Stack, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { calculateTimeAgo } from "../utils";

interface Props {
  lastLoggedIn?: string;
  domain?: string;
  name?: string;
  email?: string;
}

export function WelcomeBackHeading(props: Props) {
  const { lastLoggedIn, name, domain, email } = props;
  const { t } = useTranslation();

  const timeAgoSentence = useMemo(() => {
    const timeAgo = calculateTimeAgo(lastLoggedIn);

    if (!timeAgo) return;

    if (timeAgo.length) {
      return `You last logged into ${domain}, ${timeAgo[0]} ago.`;
    }

    if (timeAgo.length === 2) {
      return `You last logged into ${domain}, ${timeAgo[0]} and ${timeAgo[1]} ago.`;
    }
  }, [lastLoggedIn, domain]);

  const nameOrEmail = !name ? email : name;

  return (
    <>
      <Stack align="center" justify="center" gap="space-2">
        <Text style="form/page-title" color="text-base" align="center">
          {t("Welcome back")} {nameOrEmail}
        </Text>
        <Text
          style="form/body-primary"
          color="text-weak"
          align="center"
          className={styles.text}
        >
          {timeAgoSentence}
        </Text>
      </Stack>
    </>
  );
}

const styles = {
  text: css(mq({ minwidth: ["420px"] })),
};
